module.exports = __webpack_public_path__ + "img/placetopay.411d8305.png";